module.exports = __webpack_public_path__ + "employee_dark.2731351c0cad997643b6.svg";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/dummy-assets/common/img/icon/svg_icon/employee_dark.svg
// module id = ../../../../../src/assets/modules/dummy-assets/common/img/icon/svg_icon/employee_dark.svg
// module chunks = styles